import navigationType, { RELOAD } from "./navigationType";

function pageWasRefreshed() {
	return navigationType.getType() === RELOAD;
}

export default pageWasRefreshed;
